export const NEW_IMPORTATION_FORM = "newImportationForm";